import React from 'react';

const AdminTest = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>管理员测试页面</h1>
      <p>如果你能看到这个页面，说明管理员路由工作正常。</p>
    </div>
  );
};

export default AdminTest;